module.exports = __webpack_public_path__ + "static/img/default_product.46f8c20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default_product.jpg
// module id = pqgW
// module chunks = 1